import { FC } from 'react';
import { Box, ButtonBase } from '@mui/material';
import { DeltaCellProps } from './DeltaCell.props';

const DeltaCell: FC<DeltaCellProps> = ({ row, delta, onBreakdownClick, idSuffix }) => {
  const label = delta == null ? '—' : `${delta > 0 ? '+' : ''}${(delta * 100).toFixed(1)}%`;

  return (
    <Box display="flex" alignItems="center" justifyContent="center" height="100%">
      <ButtonBase
        id={`delta-cell-${row.companyId}${idSuffix ? `-${idSuffix}` : ''}`}
        onClick={() => onBreakdownClick(row)}
        sx={{
          color: 'inherit',
          cursor: 'pointer',
          fontSize: 'inherit',
          fontFamily: 'inherit',
          padding: 0,
          '&:hover': {
            textDecoration: 'underline',
          },
        }}>
        {label}
      </ButtonBase>
    </Box>
  );
};

export default DeltaCell;
